import React, { Component } from 'react';
import { createImageUrls, IPFS_GATEWAYS } from '../../utils/ipfs';

import './IPFSImageCell.css';
import OwnerCaption from "../OwnerCaption/OwnerCaption";

class IPFSImageCell extends Component {

  constructor(props) {
    super(props);

    this.state = {
      token: this.props.token,
      square: this.props.square,
      projectIdToImageURLBase: this.props.projectIdToImageURLBase,
      projectIdToImageURLExt: this.props.projectIdToImageURLExt,
      currentGatewayIndex: 0,
      imageLoaded: !!(props.preloadedImage && props.preloadedImage.complete && props.preloadedImage.naturalWidth),
      allGatewaysFailed: false,
    }
    this.onClick = this.onClick.bind(this);
    this.handleImageError = this.handleImageError.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  updateAndNotify = () => {
    this.setState({
      token: this.props.token,
      square: this.props.square,
      // Reset gateway state when token changes
      currentGatewayIndex: 0,
      imageLoaded: !!(this.props.preloadedImage && this.props.preloadedImage.complete && this.props.preloadedImage.naturalWidth),
      allGatewaysFailed: false,
    })
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token || prevProps.square !== this.props.square || prevProps.preloadedImage !== this.props.preloadedImage) {
      this.updateAndNotify();
    }
  }

  onClick(e) {
    e.preventDefault();
    this.props.handleClick(this.props.indexValue);
  };

  handleImageError(e) {
    const nextGatewayIndex = this.state.currentGatewayIndex + 1;
    const currentUrl = this.getImageUrl();

    console.log(`[IPFSImageCell] Image error for token ${this.props.token?.tokenId}, gateway index ${this.state.currentGatewayIndex}, url: ${currentUrl}`);

    if (nextGatewayIndex < IPFS_GATEWAYS.length) {
      // Try next gateway
      console.warn(`[IPFSImageCell] Gateway ${IPFS_GATEWAYS[this.state.currentGatewayIndex].name} failed for token ${this.props.token?.tokenId}, trying ${IPFS_GATEWAYS[nextGatewayIndex].name}`);
      this.setState({
        currentGatewayIndex: nextGatewayIndex,
      });
    } else {
      // All gateways failed
      console.error(`[IPFSImageCell] All IPFS gateways failed for token ${this.props.token?.tokenId}, switching to live render mode`);
      this.setState({
        allGatewaysFailed: true,
      });

      // Notify App to switch to P5 live rendering mode
      if (this.props.onIPFSUnavailable) {
        this.props.onIPFSUnavailable();
      }
    }
  }

  handleImageLoad() {
    if (this.state.currentGatewayIndex > 0) {
      console.log(`[IPFSImageCell] Successfully loaded from fallback gateway ${IPFS_GATEWAYS[this.state.currentGatewayIndex].name}`);
    }
    this.setState({ imageLoaded: true });
  }

  getImageUrl() {
    try {
      const { primary, fallbacks } = createImageUrls(
        this.props.projectIdToImageURLBase,
        this.props.token.tokenId,
        this.props.projectIdToImageURLExt
      );

      // Return URL based on current gateway index
      if (this.state.currentGatewayIndex === 0) {
        return primary;
      } else if (this.state.currentGatewayIndex <= fallbacks.length) {
        return fallbacks[this.state.currentGatewayIndex - 1];
      }
      return primary;
    } catch (e) {
      console.error('[IPFSImageCell] Error creating image URL:', e);
      return '';
    }
  }

  getPlaceholderSvg() {
    const imageCode = `<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet" viewBox="0 0 350 350">
      <style>
        .edition { fill: #c7c7c7; font-family: Open Sans; font-size: 12px; }
        .base { fill: #c7c7c7; font-family: Open Sans; font-size: 180px; }
        .txhash { fill: #c7c7c7; font-family: Open Sans; font-size: 9px; }
      </style>
      <rect width="100%" height="100%" fill="#eeeeee" />
        <text class="edition" x="50%" y="5%" dominant-baseline="middle" text-anchor="middle">Project ${this.props.token.projectId} # ${this.props.token.editionId}</text>
        <text class="edition" x="50%" y="10%" dominant-baseline="middle" text-anchor="middle">][art # ${this.props.token.tokenId}</text>
        <text class="base" x="50%" y = "50%" dominant-baseline="middle" text-anchor="middle">][</text>
        <text class="txhash" x="50%" y="95%" dominant-baseline="middle" text-anchor="middle">${this.props.token.transactionHash}</text>
      </svg>`;
    return `data:image/svg+xml;base64,${btoa(imageCode)}`;
  }

  render() {
    // If all gateways failed, return null so parent can render P5Cell
    if (this.state.allGatewaysFailed) {
      return null;
    }

    const imageURL = this.getImageUrl();
    const placeholderImageURL = this.getPlaceholderSvg();

    let WIDTH = (window.innerWidth) / this.props.square * 0.8;
    let HEIGHT = (window.innerHeight) / this.props.square * 0.8;
    let DIM = Math.min(WIDTH, HEIGHT);

    return (
      (this.state.token) ? (
      <div
        className={`cell`}
        id={this.state.token.transactionHash}
        onClick={this.onClick}>

        {/* Show placeholder SVG until image loads */}
        {!this.state.imageLoaded && (
          <img
            src={placeholderImageURL}
            alt=""
            height={`${DIM}px`}
            width={`${DIM}px`}
          />
        )}

        {/* Hidden image that tries to load - shown when successful */}
        {/* Key forces React to recreate element when gateway changes */}
        <img
          key={`img-${this.props.token.tokenId}-gateway-${this.state.currentGatewayIndex}`}
          src={imageURL}
          alt=""
          height={`${DIM}px`}
          width={`${DIM}px`}
          onError={this.handleImageError}
          onLoad={this.handleImageLoad}
          style={{ display: this.state.imageLoaded ? 'block' : 'none' }}
        />

        {(this.props.selected) ? (
          <div className="fade-in-text">
              <OwnerCaption
                tokenId={this.props.token.tokenId}
                owner={this.props.ownerOfSelectedEdition}
                asOf={this.props.ownerAsOf}
              />
          </div>
        ) : ("")}

      </div>
    ) : ("")
    );
  };
}

export default IPFSImageCell;
